import Vue from 'vue'
import VueRouter from 'vue-router'
import VueYandexMetrika from 'vue-yandex-metrika'

// import GroupsView from "@/views/GroupsView";
import SupportView from "@/views/SupportView";
// import PrepodView from "@/views/PrepodView";
import SearchSchedule from "@/components/SearchSchedule";
import FAQView from "@/views/FAQView";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'schedule',
    component: SearchSchedule, // comment if redirect
    /*
    redirect: () => {
      // the function receives the target route as the argument
      // we return a redirect path/location here.
      return { path: '/schedule' }
    },
    */
    meta: {
      layout: 'ScheduleLayout'
    }
  },
  {
    path: '/:key',
    name: 'schedule',
    component: SearchSchedule,
    meta: {
      layout: 'ScheduleLayout'
    }
  },
  {
    path: '/about/faq',
    name: 'support',
    component: FAQView,
    meta: {
      layout: 'ReadLayout'
    }
  },
  {
    path: '/about/support',
    name: 'support',
    component: SupportView,
    meta: {
      layout: 'ReadLayout'
    }
  },
    /*
  {
    path: '*',
    name: 'Error',
    // component: () => import('@/pages/Error') (Optional)
    redirect: () => {
      // the function receives the target route as the argument
      // we return a redirect path/location here.
      return { path: '/student' }
    },
    meta: {
      layout: 'DefaultLayout' // name of the layout
    }
  },
     */
]

const router = new VueRouter({
  routes
})

Vue.use(VueYandexMetrika, {
  id: 90331226,
  router: router,
  env: process.env.NODE_ENV
})

export default router
